import { useState, useEffect, useCallback } from 'react';

export const useDebounce = <T>(initialValue?: any, delay = 300) => {
  const [value, setValue] = useState<T>(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => setValue(initialValue), delay);
    return () => clearTimeout(handler);
  }, [initialValue, delay]);

  return [value, setValue] as const;
};

export const useDebounceState = <T>(initialValue?: any, delay = 300) => {
  const [value, setValue] = useState<T>(initialValue);
  const [debounceValue, setNow] = useDebounce<T>(value, delay);

  return [debounceValue, setValue, setNow] as const;
};

export const useSwitch = (initialState?: boolean) => {
  const [on, setOn] = useState(!!initialState);

  const turnOn = useCallback(() => {
    setOn(true);
  }, []);

  const turnOff = useCallback(() => {
    setOn(false);
  }, []);

  const toggle = useCallback(() => {
    setOn(!on);
  }, [on]);

  return {
    on,
    turn: setOn,
    turnOff,
    turnOn,
    toggle,
  };
};
